import React, { FC } from 'react';

import { useStyles } from './styles';

export const StageSection: FC = ({ children }) => {
  const styles = useStyles();

  return <div className={styles.section}>{children}</div>;
};
